/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isActionContentObject(obj) {
  return obj && typeof obj === 'object';
}